<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterContact" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Contact Id</mat-label>
          <input placeholder="Contact Id"
            matInput
            [matChipInputFor]="chipContactIds"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'contactIds')">
          </mat-form-field>
          <mat-chip-grid #chipContactIds>
            @for (item of contactIds; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'contactIds')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Contact Type</mat-label>
            <input placeholder="Contact Type"
              matInput
              [matChipInputFor]="chipContactTypes"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'contactTypes')">
            </mat-form-field>
            <mat-chip-grid #chipContactTypes>
              @for (item of contactTypes; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'contactTypes')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-field">
            <mat-form-field class="search-input">
              <mat-label>Contact Name</mat-label>
              <input placeholder="Contact Name"
                matInput
                [matChipInputFor]="chipContactNames"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="applyFilter($event, 'contactNames')">
              </mat-form-field>
              <mat-chip-grid #chipContactNames>
                @for (item of contactNames; track item) {
                  <mat-chip-row
                    [removable]="removable" (removed)="remove(item, 'contactNames')">
                    {{item}}
                    @if (removable) {
                      <mat-icon matChipRemove>cancel</mat-icon>
                    }
                  </mat-chip-row>
                }
              </mat-chip-grid>
            </div>
            <div class="filter-field">
              <mat-form-field class="search-input">
                <mat-label>Contact First Name</mat-label>
                <input placeholder="Contact First Name"
                  matInput
                  [matChipInputFor]="chipContactFirstNames"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="addOnBlur"
                  (matChipInputTokenEnd)="applyFilter($event, 'contactFirstNames')">
                </mat-form-field>
                <mat-chip-grid #chipContactFirstNames>
                  @for (item of contactFirstNames; track item) {
                    <mat-chip-row
                      [removable]="removable" (removed)="remove(item, 'contactFirstNames')">
                      {{item}}
                      @if (removable) {
                        <mat-icon matChipRemove>cancel</mat-icon>
                      }
                    </mat-chip-row>
                  }
                </mat-chip-grid>
              </div>
              <div class="filter-field">
                <mat-form-field class="search-input">
                  <mat-label>Contact Last Name</mat-label>
                  <input placeholder="Contact Last Name"
                    matInput
                    [matChipInputFor]="chipContactLastNames"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="applyFilter($event, 'contactLastNames')">
                  </mat-form-field>
                  <mat-chip-grid #chipContactLastNames>
                    @for (item of contactLastNames; track item) {
                      <mat-chip-row
                        [removable]="removable" (removed)="remove(item, 'contactLastNames')">
                        {{item}}
                        @if (removable) {
                          <mat-icon matChipRemove>cancel</mat-icon>
                        }
                      </mat-chip-row>
                    }
                  </mat-chip-grid>
                </div>
                <div class="filter-field">
                  <mat-form-field class="search-input">
                    <mat-label>Contact Email</mat-label>
                    <input placeholder="Contact Email"
                      matInput
                      [matChipInputFor]="chipContactEmails"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="applyFilter($event, 'contactEMails')">
                    </mat-form-field>
                    <mat-chip-grid #chipContactEmails>
                      @for (item of contactEMails; track item) {
                        <mat-chip-row
                          [removable]="removable" (removed)="remove(item, 'contactEMails')">
                          {{item}}
                          @if (removable) {
                            <mat-icon matChipRemove>cancel</mat-icon>
                          }
                        </mat-chip-row>
                      }
                    </mat-chip-grid>
                  </div>
                  <div class="filter-actions">
                    <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
                      {{
                      changeTypeButton() ? 'Reset' : 'Filter'
                      }}
                    </button>
                  </div>
                </form>
              </mat-expansion-panel>
            </mat-accordion>
